/**
 * Workbooks whose Process should be generated as soon as their page can ask
 * the assistant: the New workbook wizard files one before opening the page.
 * Held in memory only, so a reload never generates a second time.
 */
const requested = new Set<string>();

export function requestWorkbookGeneration(workbookId: string): void {
  requested.add(workbookId);
}

/** Whether generation was requested for this Workbook; answers true once. */
export function takeWorkbookGenerationRequest(workbookId: string): boolean {
  return requested.delete(workbookId);
}
